import React from "react";
import type { MeasureType, UscDisclaimerType } from "../../../../../../../shared-logic/types/UscCommonTypes";
import { formatNumberIntl } from "../../../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import DisclaimerIconWrapper from "../../../../common/DisclaimerIconWrapper";
import Text from "../../../../../../../shared-components/lexus/styles/atoms/Text";
import * as Styles from "./SpecItem.styles";

type PropsType = {
    title: string;
    measure: MeasureType;
    cultureName: string;
    disclaimer?: {
        type: UscDisclaimerType;
        reference?: string;
    };
};
const MeasureItem = ({ title, measure, cultureName, disclaimer }: PropsType): JSX.Element => (
    <Styles.SpecItem>
        <Text tag="dt" variant="paragraph-small-book" color="steel">
            {title}
            {disclaimer && <DisclaimerIconWrapper type={disclaimer.type} reference={disclaimer.reference} />}
        </Text>
        <Text tag="dd" variant="paragraph-small-book" color="midnight">
            {/* Only display a decimal if the number has one */}
            {formatNumberIntl(measure.value, cultureName)} {measure.unit.description}
        </Text>
    </Styles.SpecItem>
);

export default MeasureItem;
